import { render, staticRenderFns, recyclableRender, components } from "./u-loading-icon.vue?vue&type=template&id=8ae91632&scoped=true&"
var renderjs
import script from "./u-loading-icon.vue?vue&type=script&lang=js&"
export * from "./u-loading-icon.vue?vue&type=script&lang=js&"
import style0 from "./u-loading-icon.vue?vue&type=style&index=0&id=8ae91632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae91632",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-loading-icon/u-loading-icon.vue"
export default component.exports